var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-scroll',{ref:"vs",attrs:{"ops":_vm.ops}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }